import { render, staticRenderFns } from "./MapMarkerArtFairIcon.vue?vue&type=template&id=9c552ca4&"
import script from "./MapMarkerArtFairIcon.vue?vue&type=script&lang=js&"
export * from "./MapMarkerArtFairIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports